module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "copy",
    attrs: {
      "type": "button",
      "title": "Copy to clipboard"
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._v("\n  Copy\n  "), (_vm.show) ? _c('span', {
    staticClass: "textee"
  }, [_vm._v("\n    Copied!\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cfa6508"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Copy.vue
// module id = 266
// module chunks = 1